import APIError from '../APIError';

class SecondaryMarketError extends APIError {
  constructor(code, details = null) {
    super(code, 'SecondaryMarketError', details);
  }
}

export default SecondaryMarketError;
